import { render, staticRenderFns } from "./TrademarkRenewalReport.vue?vue&type=template&id=7c44c5cf&"
import script from "./TrademarkRenewalReport.vue?vue&type=script&lang=js&"
export * from "./TrademarkRenewalReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports